'use strict';

export default function() {
  $('.geo-prompt-modal--dismiss-button').click(function() {
    $('.geo-prompt-modal').css('display', 'none');
    var exp_date = new Date();
    exp_date.setTime(exp_date.getTime() + 30 * 24 * 60 * 60 * 1000); // set expiration to 30 days from now
    document.cookie = 'LOCATION_PROMPT_CANCELED=true; expires=' + exp_date.toGMTString() + '; path=/; SameSite=Lax';
  });

  $(document).ready(function() {
    $('#geoPromptModal').appendTo('.header-wrap');
  });
}
